var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTallDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5417 10.4166C13.8869 10.4166 14.1667 10.1368 14.1667 9.79159C14.1667 9.44642 13.8869 9.16659 13.5417 9.16659H6.45834C6.11316 9.16659 5.83334 9.44642 5.83334 9.79159C5.83334 10.1368 6.11316 10.4166 6.45834 10.4166H13.5417Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 16.4583C14.1667 16.8034 13.8869 17.0833 13.5417 17.0833H6.45834C6.11316 17.0833 5.83334 16.8034 5.83334 16.4583C5.83334 16.1131 6.11316 15.8333 6.45834 15.8333H13.5417C13.8869 15.8333 14.1667 16.1131 14.1667 16.4583Z",
    fill: "#575757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5417 13.7499C13.8869 13.7499 14.1667 13.4701 14.1667 13.1249C14.1667 12.7797 13.8869 12.4999 13.5417 12.4999H6.45834C6.11316 12.4999 5.83334 12.7797 5.83334 13.1249C5.83334 13.4701 6.11316 13.7499 6.45834 13.7499H13.5417Z",
    fill: "#575757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1659 0C3.24542 0 2.49923 0.746192 2.49923 1.66667V18.3333H0.833333C0.373096 18.3333 0 18.7064 0 19.1667C0 19.6269 0.373096 20 0.833333 20H19.1646C19.6248 20 19.9979 19.6269 19.9979 19.1667C19.9979 18.7064 19.6248 18.3333 19.1646 18.3333H17.4977V1.66667C17.4977 0.746192 16.7515 0 15.831 0H4.1659ZM4.1659 7.49923H15.831L15.831 18.3313H4.1659V7.49923Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTallDoor);
export default __webpack_public_path__ + "static/media/TallDoor.4a3f3f1965019f96719c7651656cbe89.svg";
export { ForwardRef as ReactComponent };